(function initTrainingTreatsCompare() {
  if (window.__ttcCompareInit) return;
  window.__ttcCompareInit = true;

  function setup(root) {
    if (!root || typeof root.querySelectorAll !== "function") return;

    const sections = root.matches?.("[data-training-treats-compare]")
      ? [root]
      : [...root.querySelectorAll("[data-training-treats-compare]")];

    sections.forEach((section) => {
      if (section.dataset.ready === "true") return;
      section.dataset.ready = "true";

      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const animateEnabled = section.dataset.animate !== "false";

      const showStatic = () => {
        section.classList.remove("is-reveal-armed");
        section.classList.add("is-visible");
      };

      bindTableCursor(section);

      if (!animateEnabled || reduceMotion || !("IntersectionObserver" in window)) {
        showStatic();
        section._ttcCleanup = () => {
          unbindTableCursor(section);
          section.classList.remove("is-reveal-armed", "is-visible");
          section.dataset.ready = "false";
        };
        return;
      }

      section.classList.add("is-reveal-armed");
      section.classList.remove("is-visible");

      let enterTimer = 0;
      let hasPlayed = false;
      let failsafe = 0;

      const playOnce = () => {
        if (hasPlayed) return;
        hasPlayed = true;
        if (failsafe) {
          window.clearTimeout(failsafe);
          failsafe = 0;
        }
        if (enterTimer) window.clearTimeout(enterTimer);
        enterTimer = window.setTimeout(() => {
          section.classList.add("is-visible");
        }, 30);
      };

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || hasPlayed) return;
            playOnce();
            observer.disconnect();
          });
        },
        { threshold: 0.15, rootMargin: "0px 0px -5% 0px" }
      );

      observer.observe(section);

      // Safety: never leave section stuck invisible if IO never fires
      failsafe = window.setTimeout(() => {
        if (!hasPlayed) {
          playOnce();
          observer.disconnect();
        }
      }, 8000);

      section._ttcCleanup = () => {
        observer.disconnect();
        if (enterTimer) window.clearTimeout(enterTimer);
        if (failsafe) window.clearTimeout(failsafe);
        unbindTableCursor(section);
        section.classList.remove("is-reveal-armed", "is-visible");
        section.dataset.ready = "false";
      };
    });
  }

  // Gold border glow that follows the pointer around the table edge.
  function bindTableCursor(section) {
    const shell = section.querySelector(".training-treats-compare__table-shell");
    if (!shell) return;

    const canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!canHover || reduceMotion) return;

    const onMove = (event) => {
      const rect = shell.getBoundingClientRect();
      shell.style.setProperty("--ttc-x", `${event.clientX - rect.left}px`);
      shell.style.setProperty("--ttc-y", `${event.clientY - rect.top}px`);
      shell.classList.add("is-cursor");
    };
    const onLeave = () => shell.classList.remove("is-cursor");

    shell.addEventListener("pointerenter", onMove);
    shell.addEventListener("pointermove", onMove);
    shell.addEventListener("pointerleave", onLeave);
    window.addEventListener("scroll", onLeave, { passive: true });
    section._ttcCursorUnbind = () => {
      shell.removeEventListener("pointerenter", onMove);
      shell.removeEventListener("pointermove", onMove);
      shell.removeEventListener("pointerleave", onLeave);
      window.removeEventListener("scroll", onLeave);
      shell.classList.remove("is-cursor");
    };
  }

  function unbindTableCursor(section) {
    if (typeof section._ttcCursorUnbind === "function") {
      section._ttcCursorUnbind();
      section._ttcCursorUnbind = null;
    }
  }

  const start = () => setup(document);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  document.addEventListener("shopify:section:load", (event) => {
    setup(event.target);
  });
  document.addEventListener("shopify:section:unload", (event) => {
    const root = event.target;
    if (!root || typeof root.querySelectorAll !== "function") return;
    const sections = root.matches?.("[data-training-treats-compare]")
      ? [root]
      : [...root.querySelectorAll("[data-training-treats-compare]")];
    sections.forEach((section) => {
      if (typeof section._ttcCleanup === "function") section._ttcCleanup();
    });
  });
})();
